import React, { useEffect, useRef } from 'react';
import Lottie from 'lottie-web';
import animationData from '../../assets/Search.json';

export const ActivityIndicator = ({ visible = false , message}) => {
    const lottieContainer = useRef(null);
    useEffect(() => {
        if (!visible) return null;
        Lottie.loadAnimation({
            container: lottieContainer.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData,
        });
    }, [])

    return (
        <>
        <div style={{display: 'flex',justifyContent: 'center'}}>
            <div style={{flexDirection: "column"}}>
                <div style={{ width: 260, height: 140, backgroundRepeat: 'no-repeat' }} ref={lottieContainer}></div>
                <div style={{fontWeight: 'bold'}}>{message || "Uploaded file is being processed, please wait..."}</div>
            </div>
        </div>
        </>
    )
}

// export default ActivityIndicator